// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CallStat_paper__MlOeU {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.CallStat_label__0waGR {
  font-size: 0.875rem;
}

.CallStat_value__0M4i7 {
  font-size: 1.5rem;
}

.CallStat_labelDescriptor__\\+t0dO,
.CallStat_valueDescriptor__nug3U {
  font-size: 0.6rem;
}

@media screen and (min-width: 75em) {
  .CallStat_paper__MlOeU {
    gap: 0.5rem;
  }
  .CallStat_label__0waGR {
    font-size: 0.925rem;
  }
  .CallStat_value__0M4i7 {
    font-size: 1.8125rem;
  }
  .CallStat_labelDescriptor__\\+t0dO,
  .CallStat_valueDescriptor__nug3U {
    font-size: 0.75rem;
  }
}
@media screen and (min-width: 88em) {
  .CallStat_label__0waGR {
    font-size: 1rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/reporting/components/CallStat.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAEA;;EAEE,iBAAA;AACF;;AAEA;EACE;IACE,WAAA;EACF;EAEA;IACE,mBAAA;EAAF;EAGA;IACE,oBAAA;EADF;EAIA;;IAEE,kBAAA;EAFF;AACF;AAKA;EACE;IACE,eAAA;EAHF;AACF","sourcesContent":[".paper {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.label {\n  font-size: 0.875rem;\n}\n\n.value {\n  font-size: 1.5rem;\n}\n\n.labelDescriptor,\n.valueDescriptor {\n  font-size: 0.6rem;\n}\n\n@media screen and (min-width: 75em) {\n  .paper {\n    gap: 0.5rem;\n  }\n\n  .label {\n    font-size: 0.925rem;\n  }\n\n  .value {\n    font-size: 1.8125rem;\n  }\n\n  .labelDescriptor,\n  .valueDescriptor {\n    font-size: 0.75rem;\n  }\n}\n\n@media screen and (min-width: 88em) {\n  .label {\n    font-size: 1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"paper": `CallStat_paper__MlOeU`,
	"label": `CallStat_label__0waGR`,
	"value": `CallStat_value__0M4i7`,
	"labelDescriptor": `CallStat_labelDescriptor__+t0dO`,
	"valueDescriptor": `CallStat_valueDescriptor__nug3U`
};
export default ___CSS_LOADER_EXPORT___;
